/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const PlayIcon = ({ className }) => {
  return (
    <svg
    style={{transform: 'rotate(270deg)'}}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M15.5417 5.99905L5.88168 0.459049C5.35896 0.157209 4.76567 -0.000912568 4.16207 0.000745326C3.55847 0.00240322 2.96606 0.163781 2.44501 0.468489C1.92396 0.773196 1.49283 1.21038 1.19542 1.73563C0.898015 2.26088 0.744917 2.85548 0.75168 3.45905V14.579C0.75168 15.4861 1.112 16.356 1.75337 16.9974C2.39475 17.6387 3.26464 17.9991 4.17168 17.9991C4.77212 17.998 5.36177 17.8394 5.88168 17.5391L15.5417 11.999C16.0607 11.6986 16.4917 11.267 16.7913 10.7475C17.0909 10.228 17.2486 9.63877 17.2486 9.03905C17.2486 8.43933 17.0909 7.85015 16.7913 7.33061C16.4917 6.81108 16.0607 6.37946 15.5417 6.07905V5.99905ZM14.5417 10.189L4.88168 15.809C4.66517 15.9318 4.42055 15.9963 4.17168 15.9963C3.92281 15.9963 3.67819 15.9318 3.46168 15.809C3.24578 15.6844 3.0665 15.5051 2.94186 15.2892C2.81723 15.0733 2.75164 14.8284 2.75168 14.579V3.41905C2.75164 3.16975 2.81723 2.92482 2.94186 2.70891C3.0665 2.493 3.24578 2.3137 3.46168 2.18905C3.67909 2.06821 3.92298 2.00294 4.17168 1.99905C4.42021 2.00415 4.66382 2.06934 4.88168 2.18905L14.5417 7.76905C14.7577 7.89365 14.937 8.07292 15.0617 8.28884C15.1864 8.50476 15.2521 8.7497 15.2521 8.99905C15.2521 9.24839 15.1864 9.49334 15.0617 9.70926C14.937 9.92518 14.7577 10.1045 14.5417 10.229V10.189Z"
        fill="#F6FAFD"
      />
    </svg>
  )
}
